import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-763c4f7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Document = _resolveComponent("Document")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_avatar = _resolveComponent("el-avatar")!

  return (_ctx.type == 'file')
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        class: "filename",
        href: _ctx.url,
        target: "_blank",
        style: {"font-size":"20px"}
      }, [
        _createVNode(_component_el_icon, { title: "预览" }, {
          default: _withCtx(() => [
            _createVNode(_component_Document)
          ]),
          _: 1
        })
      ], 8, _hoisted_1))
    : (_ctx.type == 'Flag')
      ? (_openBlock(), _createBlock(_component_el_image, {
          key: 1,
          class: "thumbnail",
          style: {"width":"38px","height":"25px"},
          src: _ctx.url,
          fit: "contain"
        }, null, 8, ["src"]))
      : (_ctx.type == 'image')
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
            (
        _ctx.url != null &&
        _ctx.url != undefined &&
        typeof _ctx.url != 'undefined' &&
        _ctx.url != '' &&
        _ctx.url != 'undefined'
      )
              ? (_openBlock(), _createBlock(_component_el_image, {
                  key: 0,
                  class: "thumbnail",
                  style: {"height":"30px","cursor":"pointer"},
                  src: _ctx.url,
                  fit: "contain",
                  onClick: _ctx.onDetail
                }, null, 8, ["src", "onClick"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_3, "暂无数据"))
          ]))
        : (_openBlock(), _createBlock(_component_el_avatar, {
            key: 3,
            class: "thumbnail",
            size: _ctx.size,
            src: _ctx.url
          }, null, 8, ["size", "src"]))
}